import { FormBase } from "../../util/form-base-form";
import { Roles } from "../../constants/roles";

export class FilterSidebarToggleForm extends FormBase {
    public constructor(private readonly root: Element) {
        super();
    }

    public getToggleButton(): HTMLElement | null {
        return this.queryElement(this.root, `[data-role="${Roles.FILTER_SIDEBAR_TOGGLE}"]`);
    }

    public getMobileToggleButton(): HTMLElement | null {
        return this.queryElement(this.root, `[data-role="${Roles.FILTER_SIDEBAR_MOBILE_TOGGLE}"]`);
    }

    public getMobileToggleButtonWrapper(): HTMLElement | null {
        return this.closest(this.getMobileToggleButton(), ".navbar-search", HTMLElement);
    }

    public getAdminSearchTrigger(): HTMLElement | null {
        return this.queryElement(this.root, `[data-role="${Roles.NAVBAR_ADMIN_SEARCH_TRIGGER}"]`);
    }

    public getWrapper(): HTMLElement | null {
        return this.queryElement(this.root, `[data-role="${Roles.FILTER_SIDEBAR_WRAPPER}"]`);
    }

    public getSidebar(): HTMLElement | null {
        return this.queryElement(this.root, `[data-role="${Roles.FILTER_SIDEBAR}"]`);
    }

    public getDragHandle(): HTMLElement | null {
        return this.queryElement(this.root, `[data-role="${Roles.FILTER_SIDEBAR_DRAG_HANDLE}"]`);
    }
}
